import { render, staticRenderFns } from "./ECommerce.vue?vue&type=template&id=ac4ba58e&scoped=true&"
var script = {}
import style0 from "./ECommerce.vue?vue&type=style&index=0&id=ac4ba58e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4ba58e",
  null
  
)

export default component.exports